import {
  QueryClient,
  QueryKey,
  UseSuspenseQueryOptions,
  UseQueryOptions,
  useQuery as useReactQuery,
  useSuspenseQuery as useReactSuspenseQuery,
} from "@tanstack/react-query";

export const queryClient = new QueryClient();
export { QueryClient };

// useQuery senza suspense
export function useQuery<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey
>(options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>) {
  return useReactQuery<TQueryFnData, TError, TData, TQueryKey>({
    ...options,
  });
}
export function useSuspenseQuery<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey
>(options: UseSuspenseQueryOptions<TQueryFnData, TError, TData, TQueryKey>) {
  return useReactSuspenseQuery<TQueryFnData, TError, TData, TQueryKey>(options);
}
